const tabsReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_TAB':
      return action.tab;
    default:
      return state;
  }
};

export { tabsReducer as default };
